import React from 'react';
import ResumeSinceRow from './ResumeSinceRow';
import ResumeSinceHeadingRow from './ResumeSinceHeadingRow';

class ResumeSinceSubSection extends React.Component {

    constructor(props) {
        super();
    }

    getContents(item) {
        if(this.props.data.type === "since") {
            return <ResumeSinceRow data={item} currStyles={this.props.currStyles} />
        } else {
            return <ResumeSinceRow data={{name:"test", since:"tester"}} currStyles={this.props.currStyles} />
        }
    }

    render() {

        return (
            <section style={this.props.currStyles.Body.SinceSubSection}>
                <span style={this.props.currStyles.Body.SinceSubSection.title}>{this.props.data.title}</span>
                <ResumeSinceHeadingRow currStyles={this.props.currStyles} />
                {this.props.data.items.map((item) =>
                    this.getContents(item)
                )}
            </section>
        );
    }
}

export default ResumeSinceSubSection




// WEBPACK FOOTER //
// src/ResumeAndDocs/ResumeSinceSubSection.js